/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Pallet_LocationInputs */

const en_cargos_pallet_location = /** @type {(inputs: Cargos_Pallet_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pallet Location`)
};

const es_cargos_pallet_location = /** @type {(inputs: Cargos_Pallet_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicacion de pallet`)
};

/**
* | output |
* | --- |
* | "Pallet Location" |
*
* @param {Cargos_Pallet_LocationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_pallet_location = /** @type {((inputs?: Cargos_Pallet_LocationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Pallet_LocationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_pallet_location(inputs)
	return es_cargos_pallet_location(inputs)
});